/**
 * 用途: テンプレート側で安全にHTMLをバインドするためのパイプ。
 * 例: <div [innerHTML]="rawHtml | safeHtml"></div>
 * - DomSanitizerの一元化サービスを利用し、サニタイズ後に SafeHtml を返します。
 * - standalone pipe のため、各コンポーネントで imports に追加するだけで使用可能。
 */
import { inject, Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SanitizerService } from './sanitizer.service';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(SanitizerService);

  transform(value: string | null | undefined): SafeHtml {
    return this.sanitizer.safeHtml(value);
  }
}
